import { RightArrowIcon } from "assets/icons";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { Button } from "ui";

import { AffinityBlacklistEntry } from "../../recommendation.types";

import styles from "./AffinityBlacklistList.module.scss";

interface AffinityBlacklistListProps {
  entries: AffinityBlacklistEntry[];
  isLoading?: boolean;
  unblockingId: string | null;
  emptyText: string;
  onUnblock: (entry: AffinityBlacklistEntry) => void;
}

const AffinityBlacklistList = ({
  entries,
  isLoading,
  unblockingId,
  emptyText,
  onUnblock
}: AffinityBlacklistListProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeleton count={3} height={48} borderRadius={10} />;
  }

  if (!entries.length) {
    return <p className={styles.empty}>{emptyText}</p>;
  }

  return (
    <div className={styles.list}>
      {entries.map((entry) => (
        <div key={entry.id} className={styles.entry}>
          <span className={styles.entry__from}>
            {entry.fromName ?? t("Unknown category")}
          </span>

          <RightArrowIcon
            className={styles.entry__arrow}
            width={16}
            height={16}
          />

          <span className={styles.entry__to}>
            {entry.toName ?? t("Unknown category")}
          </span>

          <span className={styles.entry__reason}>{entry.reason ?? ""}</span>

          <span className={styles.entry__date}>
            {moment(entry.createdAt).format("DD/MM/YYYY")}
          </span>

          <Button
            variant="default"
            size="sm"
            loading={unblockingId === entry.id}
            onClick={() => onUnblock(entry)}
          >
            {t("Unblock")}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default AffinityBlacklistList;
